const typographyFonts = {
  // [title]
  title: {
    fontSize: '36px',
    fontWeight: 'bold',
    lineHeight: '45px',
  },
  // [titleSM]
  titleSM: {
    fontSize: '26px',
    fontWeight: 'bold',
    lineHeight: '25px',
  },
  // [subtitle]
  subtitle: {
    fontSize: '20px',
    fontWeight: '600',
    lineHeight: '25px',
  },
  // [text]
  text: {
    fontSize: '16px',
    fontWeight: 'normal',
    lineHeight: '20px',
  },
  // [link]
  link: {
    fontSize: '16px',
    fontWeight: 'bold',
    lineHeight: '20px',
  },
};

export default typographyFonts;
